import { render, staticRenderFns } from "./AddWaitingTeamCard.vue?vue&type=template&id=947f54b8&scoped=true"
import script from "./AddWaitingTeamCard.vue?vue&type=script&lang=js"
export * from "./AddWaitingTeamCard.vue?vue&type=script&lang=js"
import style0 from "./AddWaitingTeamCard.vue?vue&type=style&index=0&id=947f54b8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "947f54b8",
  null
  
)

export default component.exports